<template>
  <v-app-bar
    v-bind="$attrs"
    dense
    flat
  >
    <slot></slot>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppBar",
};
</script>

<style scoped></style>
